<template>
  <HomeHeader />
  <div class="ts-container">
    <div class="ts-grid is-relaxed is-3-columns is-stackable">
      <div class="column">
        <div class="ts-header is-big">No tab disappearing</div>
        <span class="ts-text">Just unload it from memory. You can reload it anytime if you want.</span>
      </div>
      <div class="column">
        <div class="ts-header is-big">Simple to use</div>
        <span class="ts-text">Just click your mouse. Unload tabs in 5 mode.</span>
      </div>
      <div class="column">
        <div class="ts-header is-big">No more memory waste</div>
        <span class="ts-text">Unload tabs. Recapture your own memory.</span>
      </div>
    </div>
    <div class="ts-space is-big"></div>
    <div class="ts-header is-huge">New in tabs unloader 2.0</div>
    <div class="ts-list is-unordered">
      <div class="item">Brand new operating procedure</div>
      <div class="item">Anti mistouch</div>
      <div class="item">Startup unloader</div>
      <div class="item">Performance improve</div>
    </div>
    <div class="ts-space is-big"></div>
    <div class="ts-box">
      <div class="ts-content">
        <p>We promise that this extension will free to use forever.</p>
      </div>
      <div class="symbol">
        <span class="ts-icon is-circle-exclamation-icon"></span>
      </div>
    </div>
  </div>
  <PageFooter />
</template>

<script>
// @ is an alias to /src
import HomeHeader from "@/components/HomeHeader.vue";
import PageFooter from "@/components/PageFooter.vue";

export default {
  name: "HomeView",
  components: {
    HomeHeader,
    PageFooter,
  },
};
</script>
